/*eslint no-process-env:0*/

// Development specific configuration
// ==================================
module.exports = {
    // Sequelize connection options
    sequelize: {
        host: process.env.MYSQL_HOST,
        username: process.env.MYSQL_USER,
        password: process.env.MYSQL_PWD,
        database: process.env.MYSQL_DATABASE,
        dialect: 'mysql',
        port: process.env.MYSQL_PORT
    },
    url: process.env.URL,
    clientContact: process.env.URL_CONTACT_CLIENT,
    apiContact: process.env.URL_CONTACT_API,
    transfer: process.env.URL_TRANSFER,
    auth: process.env.URL_AUTH,
    officialMail: process.env.EMAIL_OFFICIAL,
    // Seed database on startup
    seedDB: process.env.SEED_DB,
    requestMail: process.env.EMAIL_REQUEST
};
